export const useCardCourseGenreData = () => {

  const config = useRuntimeConfig()
  const transform = (response) => {
    const { sanitize } = useUtils();
    return {
      cardCourseGenre: sanitize(response.data.attributes.cardCourseGenre),
    }
  }    
  const getCardCourseGenre = async (deep = true) => {        
    const url = `/api/card-course-genre`;

    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
  }

  return {
    getCardCourseGenre,
  }
}